import { createSlice } from "@reduxjs/toolkit";

const initialState={
    // TODO: Change this back to "https://quirckart.in/" when deploying to production
    // baseUrl: "https://quirckart.in/",               // â†  PRODUCTION
    // baseUrl: window.location.origin + "/",           // â†  AUTO-DETECT
    // baseUrl: "http://foodporium-env.eba-wnzyt2im.eu-north-1.elasticbeanstalk.com/", // â†  OLD AWS
    baseUrl: "https://quirckart.in/",                  // â†  LOCAL DEV (active)
}

const ApiBaseUrlSlice= createSlice({
    name:"ApiBaseUrl",
    initialState,
    reducers:{
        setApiBaseUrl:(state,action)=>{
            state.baseUrl=action.payload;
        }
    }
});

export const{
    setApiBaseUrl
}=ApiBaseUrlSlice.actions;
export default ApiBaseUrlSlice.reducer;

